import React, {useEffect, useState, useRef} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {getLanguage, t} from 'react-switch-lang';
import {
  getAllCourtCategoryRisks,
  createCourtCategoryRisk,
  deleteCourtCategoryRisk,
  updateCourtCategoryRisk,
} from '../../../services/CourtCategoryRisks/courtCategoryRisks';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import Swal from "sweetalert2";
import AddIcon from "../Metodologies/plus.png";

const CourtCategoryRisks = () => {
  const [courtCategoryRisks, setCourtCategoryRisks] = useState([]);
  const [query, setQuery] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllCourtCategoryRisks();
        setCourtCategoryRisks(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('common.name'),
      editable: true,
      placeholder:`${t('common.placeholder.name')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('common.nameEn'),
      editable: true,
      placeholder:`${t('common.placeholder.nameEn')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
       
        {max: 50, message: t('message.max', {max: 50})},
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.id = editingRecord.id
    try {
      const response = await updateCourtCategoryRisk(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess3', {entity: t('courtCategoryRisks.courtCategoryRisk')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('courtCategoryRisks.courtCategoryRiskExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('courtCategoryRisks.courtCategoryRiskExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createCourtCategoryRisk(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('message.addSuccess3', {entity: t('courtCategoryRisks.courtCategoryRisk')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('courtCategoryRisks.courtCategoryRiskExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('courtCategoryRisks.courtCategoryRiskExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('courtCategoryRisks.courtCategoryRisk'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete2').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deleteCourtCategoryRisk(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess3', {entity: t('courtCategoryRisks.courtCategoryRisk')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('message.deleteFailed', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const addButton = useRef();

  return (
    <div className="court-category-risks administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('courtCategoryRisks.searchCourtCategoryRisks')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('courtCategoryRisks.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/court-category-risks"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default CourtCategoryRisks;